export default "__VITE_ASSET__d4025609__"